import { FilteredUsers } from '@/apis/aniftyBackend/creations/interface';
import createMiddleEllipsis from '@/utils/createMiddleEllipsis';

/**
 * Get displayName of user
 * according to their user type and current locale
 *
 * @param user user object
 * @param locale current locale (`en` or `ja`)
 * @returns {string} display name
 */
const getDisplayName2 = (user: FilteredUsers, locale = 'en'): string => {
  if (!user.CollectorProfile && !user.CreatorProfile) {
    return createMiddleEllipsis(user.UserID);
  }

  if (user.TypeID === 1) {
    // collector
    if (
      !user.CollectorProfile?.DisplayNameJA &&
      !user.CollectorProfile?.DisplayName
    ) {
      return createMiddleEllipsis(user.UserID);
    }
    if (locale === 'ja' && user.CollectorProfile.DisplayNameJA) {
      return user.CollectorProfile?.DisplayNameJA;
    } else {
      return user.CollectorProfile?.DisplayName;
    }
  } else {
    // creator
    if (
      !user.CreatorProfile?.DisplayNameJA &&
      !user.CreatorProfile?.DisplayNameEN
    ) {
      return createMiddleEllipsis(user.UserID);
    }
    if (locale === 'ja' && user.CreatorProfile.DisplayNameJA) {
      return user.CreatorProfile.DisplayNameJA;
    } else {
      return user.CreatorProfile.DisplayNameEN;
    }
  }
};

export default getDisplayName2;
